import React, { useEffect, useState } from 'react';
import useUserContext from 'Context/UserContext';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ReminderSection from 'Components/AdvisorApp/Viewport/TodayDashboard/Reminders/ReminderSection';
import MuiLink from '@material-ui/core/Link';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { Typography } from '@material-ui/core';
import { sum } from 'lodash/math';

const styles = theme => ({
  root: {
    height: '100%',
    position: 'relative',
  },
  reminderLayout: {
    height: '95%',
  },
  reminderSections: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    height: '100%',
    paddingTop: theme.spacing(1),
  },
  seeAllLink: {
    position: 'absolute',
    bottom: '0px',
    marginLeft: theme.spacing(2),
  },
});

const filterByType = type => resource => resource.attr('type') === type;

const RemindersBase = ({
  className,
  classes,
  expanded,
}) => {
  const { agentResource } = useUserContext();
  const [emailsReminderItems, setEmailReminderItems] = useState([]);
  const [messagesReminderItems, setMessagesReminderItems] = useState([]);
  const [meetingsReminderItems, setMeetingsReminderItems] = useState([]);
  const [birthdayReminderItems, setBirthdayReminderItems] = useState([]);
  const [anniversaryReminderItems, setAnniversaryReminderItems] = useState([]);
  const [scheduledMeetingAgendaReminderItems, setScheduledMeetingAgendaReminderItems] = useState([]);
  const [householdRecentMessageReminderItems, setHouseholdRecentMessageReminderItems] = useState([]);

  async function fetchReminders() {
    const collection = await agentResource?.relationship('reminders')?.link('related')?.Get();
    const collectionList = collection.resources().list();
    setEmailReminderItems(collectionList.filter(filterByType('email')));
    setMessagesReminderItems(collectionList.filter(filterByType('message')));
    setMeetingsReminderItems(collectionList.filter(filterByType('meeting')));
    setBirthdayReminderItems(collectionList.filter(filterByType('birthday')));
    setAnniversaryReminderItems(collectionList.filter(filterByType('anniversary')));
    setScheduledMeetingAgendaReminderItems(collectionList.filter(filterByType('schedule-send-meeting-agenda')));
    setHouseholdRecentMessageReminderItems(collectionList.filter(filterByType('householdRecentMessage')));
  }

  useEffect(() => {
    fetchReminders();
  }, [agentResource?.id()]);

  const reminderCount = sum([
    emailsReminderItems.length,
    messagesReminderItems.length,
    meetingsReminderItems.length,
    birthdayReminderItems.length,
    anniversaryReminderItems.length,
    scheduledMeetingAgendaReminderItems.length,
    householdRecentMessageReminderItems.length,
  ]);

  const showSeeMoreLink = !expanded && (reminderCount > 0);

  return (
    <>
      <div className={classNames(classes.root, className)}>
        <div className={classes.reminderSections}>
          <ReminderSection expanded={expanded} title="Birthdays" reminderItems={birthdayReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="Anniversaries" reminderItems={anniversaryReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="Emails to Follow-up" reminderItems={emailsReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="Messages to Follow-up" reminderItems={messagesReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="30+ Day Meetings" reminderItems={meetingsReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="Scheduled Meeting Agendas" reminderItems={scheduledMeetingAgendaReminderItems} refreshReminders={fetchReminders} />
          <ReminderSection expanded={expanded} title="Clients not contacted in 6+ Weeks" reminderItems={householdRecentMessageReminderItems} refreshReminders={fetchReminders} />
        </div>
      </div>
      {showSeeMoreLink && (
        <MuiLink
          className={classes.seeAllLink}
          href="#"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            openModal(modalConsts.remindersDialog);
          }}
        >
          <Typography variant="h5" className={classes.seeMoreText}>See all ({reminderCount})</Typography>
        </MuiLink>
      )}
    </>
  );
};

RemindersBase.defaultProps = {
  className: '',
  expanded: false,
};

RemindersBase.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
};

export default withStyles(styles)(RemindersBase);
